import {CtModelRouteData} from "@ctsolution/ct-framework";

/**
 * Route data per ContactInformation
 * Gestisce le informazioni di contatto (email, telefono, fax, PEC, ecc.)
 */
export const ContactInformationRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("contactinformation");
